import React, { useState } from 'react';
import { Avatar, Menu, Text, UnstyledButton } from '@mantine/core';
import { useAppContext } from '../contexts/AppContext';
import { weergavenaam } from '../utils/gebruikers';
import AdminPanel from './AdminPanel';
import HelpPaneel from './HelpPaneel';

// Initialen uit de gebruikersnaam: "tijn.vanderboon@..." -> "TV";
// zonder scheidingsteken de eerste twee letters.
export function initialen(username) {
  if (!username) return '?';
  const lokaal = username.split('@')[0];
  const delen = lokaal.split(/[._-]+/).filter(Boolean);
  if (delen.length >= 2) {
    return (delen[0][0] + delen[delen.length - 1][0]).toUpperCase();
  }
  return lokaal.slice(0, 2).toUpperCase();
}

// Gebruikersmenu rechtsboven: cirkel met initialen, daaronder accountinfo,
// Beheer (alleen beheerders) en Uitloggen.
export default function UserMenu({ onLogout }) {
  const { user } = useAppContext();
  const [beheerSectie, setBeheerSectie] = useState(null);  // gebruikers|import|audit|changelog|feedback
  const [helpOpen, setHelpOpen] = useState(false);
  if (!user) return null;
  const isBeheerder = !!user.admin;

  return (
    <>
      <Menu shadow="md" width={240} position="bottom-end" transitionProps={{ duration: 0 }}>
        <Menu.Target>
          <UnstyledButton
            aria-label="Gebruikersmenu"
            style={{ position: 'absolute', top: 10, right: 10, zIndex: 10 }}
          >
            <Avatar
              color="groen" variant="filled" radius="xl" size={38}
              style={{ border: '2px solid #fff', boxShadow: '0 1px 4px rgba(0,0,0,0.3)', cursor: 'pointer' }}
            >
              {initialen(user.username)}
            </Avatar>
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Label>
            <Text size="sm" fw={600} c="dark" style={{ wordBreak: 'break-word' }}>
              {weergavenaam(user)}
            </Text>
            <Text size="xs" c="dimmed">
              {user.gemeentenaam}{user.functierol ? ` — ${user.functierol}` : ''}
            </Text>
          </Menu.Label>
          <Menu.Divider />
          {isBeheerder && (
            <>
              <Menu.Label>Beheer</Menu.Label>
              <Menu.Item onClick={() => setBeheerSectie('gebruikers')}>Gebruikersbeheer</Menu.Item>
              <Menu.Item onClick={() => setBeheerSectie('import')}>Data-import</Menu.Item>
              <Menu.Item onClick={() => setBeheerSectie('audit')}>Recente wijzigingen</Menu.Item>
              <Menu.Item onClick={() => setBeheerSectie('changelog')}>Changelog</Menu.Item>
              <Menu.Item onClick={() => setBeheerSectie('feedback')}>Op- en aanmerkingen</Menu.Item>
              <Menu.Divider />
            </>
          )}
          <Menu.Item onClick={() => setHelpOpen(true)}>Uitleg</Menu.Item>
          <Menu.Item color="red" onClick={onLogout}>Uitloggen</Menu.Item>
        </Menu.Dropdown>
      </Menu>
      {isBeheerder && (
        <AdminPanel sectie={beheerSectie} onClose={() => setBeheerSectie(null)} />
      )}
      <HelpPaneel open={helpOpen} onClose={() => setHelpOpen(false)} />
    </>
  );
}
